import React from 'react';
import { useLocation } from 'react-router-dom';
import { Typography, Button } from 'antd';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import LogoImg from '../../media/builty-logo.svg';
import './Header.scss';

const { Title } = Typography;

const getPageTitle = path => {
  switch (path) {
    case '/': return 'Coverage';
    case '/api-keys': return 'API Keys';
    case '/permit-lookup': return 'Permit Lookup';
    case '/api-usage': return 'API Usage';
    case '/billing': return 'Billing';
    case '/settings': return 'Settings';
    case '/team': return 'Team';
    case '/documentation': return 'Documentation';
    default: return 'Builty Portal';
  }
}

export const Header = ({ isNavActive, toggleNav }) => {
  const location = useLocation();
  const title = getPageTitle(location?.pathname);

  return (
    <div className="c-header">
      <div className="c-header__mobile">
        <div className="c-header__mobile-toggle-nav-btn">
          <Button
            type="primary"
            size="large"
            icon={isNavActive ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
            onClick={toggleNav}
          />
        </div>
        <div className="c-header__mobile-logo">
          <div>
            <a href="https://builty.app">
              <img src={LogoImg} alt="Builty Logo" width="210" height="31" className="c-header__mobile-logo-img" />
            </a>
          </div>
          <div className='c-header__mobile-logo-beta'>beta</div>
        </div>
      </div>
      <div className="c-header__inner">
        <div className="c-header__col-main">
          <Title level={3} className="c-header__title">{title}</Title>
          <div className="c-header__subtitle">
          
          </div>
        </div>
        <div className="c-header__col-info">
          <Button type="primary" size="medium" href="mailto:info@builty.app">
            Contact us
          </Button>
        </div>
      </div>
    </div>
  );
}
